export default function productDetailScroll () {
	var elm = document.querySelector('#schedule-timeline');
	var ms = new MenuSpy(elm, {
		activeClass: "active",
		threshold: 300,
		callback: function (currentItem) {
			console.log("🚀 ~ ms ~ currentItem:", currentItem)
			// const nodeParent = $(".section-scrollTo-active");
			// $(nodeParent).scrollTo("li.active", 800);
		},
	});
}
